import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getPageType } from '../../util/page';
import FileNotFound from '../FileNotFound';

class HistoryWidget extends Component {
  render() {
    const { searchData } = this.props;
    let history;
    try {
      history = JSON.parse(localStorage.getItem('user.page.history') || []);
    } catch (e) {
      history = [];
    }

    return (
      <>
        {!history || Object.keys(history).length === 0 ? (
          <FileNotFound>Empty</FileNotFound>
        ) : (
          history.map(pageName => {
            if (!searchData[pageName]) {
              return null;
            }
            const icon = <i className={`zmdi zmdi-${getPageType(searchData[pageName].type).icon} zmdi-hc-fw`} />;
            return (
              <Link className="dashboard-link" key={`history-${pageName}`} to={`/${pageName}`}>
                {icon} <b>{pageName}</b> - {searchData[pageName].title}
              </Link>
            );
          })
        )}
      </>
    );
  }
}

HistoryWidget.propTypes = {
  searchData: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    searchData: state.app.searchData,
  };
}

export default connect(mapStateToProps)(HistoryWidget);
